import "./../App.css";
import { Element } from "react-scroll";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <Element name="About" className="element">
      <div
        id="About"
        className="About gap-10 flex flex-wrap place-content-evenly bg-gradient-to-b from-home-page to-about-background h-8.5hpx p-x-10 pt-36
        smw:gap-5 smw:flex-nowrap smw:flex-col smw:h-1.1kpx"
      >
        <Link
          className="spiritual-life card rounded-lg border-black bg-white drop-shadow-md p-4
          smw:p-2 flex w-5/12 smw:w-11/12 smw:m-4 hover:opacity-80"
          to="/spiritual-life"
        >
          <img
            className="w-60 h-60 p-2 border rounded
            smw:w-40 smw:h-40 smw:p-1"
            src={process.env.PUBLIC_URL + "/images/spiritual-life.jpg"}
            alt="Spiritual Life"
          />
          <div className="information w-full text-center p-2 smw:p-0">
            <h2 className="text-2xl smw:text-md smw:pt-1">Spiritual Life</h2>
            <p className="p-2 smw:text-xs">
              I am a New Testament Christian and a servant of God. I believe the
              Bible is the book of truth and is inspired by God
              {" ("}
              <a
                className="hover:text-blue-600 active:text-blue-900"
                href="https://www.blueletterbible.org/nkjv/2ti/3/16/s_1128016"
              >
                2 Timothy 3:16
              </a>
              {")"}.
            </p>
            <p className="pt-3 xsw:hidden">
              Click here for more information about what I believe{" "}
            </p>
          </div>
        </Link>
        <Link
          className="work-life card rounded-lg border-black bg-white drop-shadow-md p-4
          smw:p-2 flex w-5/12 smw:w-11/12 smw:m-4 hover:opacity-80"
          to="/career"
        >
          <img
            className="w-60 h-60 p-2 border rounded
            smw:w-40 smw:h-40 smw:p-1"
            src={process.env.PUBLIC_URL + "/images/work-life.jpg"}
            alt="Spiritual Life"
          />
          <div className="information w-full text-center p-2smw:p-0">
            <h2 className="text-2xl smw:text-md smw:pt-1">Career</h2>
            <p className="p-2 smw:text-xs">
              I am a dedicated software engineer with a passion for coding. I
              enjoy challenging tasks that drive me to learn new things and
              develop new skills. Seeing a product finally work the way it
              should brings me so much joy and satisfaction!
            </p>
            <p className="pt-3 xsw:hidden">
              Click here for more information about my skill set and work
              experience{" "}
            </p>
          </div>
        </Link>
        <Link
          className="education-life card rounded-lg border-black bg-white drop-shadow-md p-4
          smw:p-2 flex w-5/12 smw:w-11/12 smw:m-4 hover:opacity-80"
          to="/education"
        >
          <img
            className="w-60 h-60 p-2 border rounded
            smw:w-40 smw:h-40 smw:p-1"
            src={process.env.PUBLIC_URL + "/images/education-life.jpg"}
            alt="Education Life"
          />
          <div className="information w-full text-center p-2smw:p-0">
            <h2 className="text-2xl smw:text-md smw:pt-1">Education</h2>
            <p className="p-2 smw:text-xs">
              I graduated from Freed-Hardeman University with a bachelor's in
              computer science with an emphasis in software development. I
              intend to enroll at Georgia Tech to attain my master's with a
              focus on human-computer interaction.
            </p>
            <p className="pt-3 xsw:hidden">
              Click here for more information about my education{" "}
            </p>
          </div>
        </Link>
        <Link
          className="personal-life card rounded-lg border-black bg-white drop-shadow-md p-4
          smw:p-2 flex w-5/12 smw:w-11/12 smw:m-4 hover:opacity-80"
          to="/hobbies"
        >
          <img
            className="w-60 h-60 p-2 border rounded
            smw:w-40 smw:h-40 smw:p-1"
            src={process.env.PUBLIC_URL + "/images/personal-life.jpg"}
            alt="Spiritual Life"
          />
          <div className="information w-full text-center p-2smw:p-0">
            <h2 className="text-2xl smw:text-md smw:pt-1">
              Recreation and Hobbies
            </h2>
            <p className="p-2 smw:text-xs">
              I love to play ping pong, disc golf, and other outdoor games. I
              also enjoy board games, card games, and select video games. I am
              enthusiastic about designing games, various arts and crafts, and
              other creative hobbies.
            </p>
            <p className="pt-3 xsw:hidden">
              Click here for more information about my hobbies and recreational
              activities{" "}
            </p>
          </div>
        </Link>
      </div>
    </Element>
  );
}
